/**
 * Botón "Refrescar" estándar.
 *
 * Bypassea el KV cache (force=true) y va directo a ESI. Espera a que
 * el fetch termine antes de aceptar otro click (disabled por isFetching).
 *
 * Uso:
 *   <RefreshButton onClick={bump} isFetching={isFetching} />
 */
export function RefreshButton({
  onClick,
  isFetching = false,
  className = '',
}: {
  onClick: () => void
  isFetching?: boolean
  className?: string
}) {
  return (
    <button
      onClick={onClick}
      disabled={isFetching}
      title="Bypassea el KV cache y va directo a ESI."
      className={`text-xs px-2 py-0.5 rounded border border-eve-border bg-eve-panel text-eve-muted hover:text-eve-accent hover:border-eve-accent transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {isFetching ? '…' : '↻ Refrescar'}
    </button>
  )
}
